module.exports = __webpack_public_path__ + "img/about/80243-002.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-002.png
// module id = 12
// module chunks = 0